namespace HA.Core.HTML.Navigation {
    //noinspection TsLint
    export class Navigation extends Container {
        public getTagName(): string {
            return "nav";
        }

        protected initialize(data: any) {
            super.initialize(data);
            const color = this.translate("#bgColor");
            const useTransparent = this.translate("#useTransparent");
            if (color && useTransparent) {
                timeout(() => {
                    const nav = document.querySelector('nav');
                    window.addEventListener('scroll', function (event) {
                        event.preventDefault();
                        if (window.scrollY <= window.innerHeight) {
                            nav.style.backgroundColor = 'transparent';
                        } else {
                            nav.style.backgroundColor = color;
                        }
                    });

                    nav.style.backgroundColor = 'transparent';
                }, 200);
            } else if (color) {
                timeout(() => {
                    const nav = document.querySelector('nav');
                    nav.style.backgroundColor = color;
                }, 200);
            }
        }
    }
}
